import type {FC} from 'react';
import clsx from 'clsx';

import type {FeaturedLinksSchema} from 'components/content-blocks/featured-links/schema';

import {FeaturedLink} from './featured-link';

interface Props {
	section: FeaturedLinksSchema;
	isDraft: boolean;
}

export const FeaturedLinks: FC<Props> = ({section, isDraft}) => {
	return (
		<div className={clsx('flex', 'justify-center', 'relative')}>
			<div className={clsx('grid', 'max-w-7xl', 'w-full', 'p-3', 'gap-3', 'lg:grid-cols-2')}>
				{section.links?.map((link) => {
					return <FeaturedLink key={link._key} featuredLink={link} isDraft={isDraft} />;
				})}
			</div>
		</div>
	);
};
